<div id="baseline-clinical-data" class="wrapper mt-20">
  <div [formGroup]="baselineClinicalDataFormGroup">
        <input type="hidden" name="patientid" [ngModel]="patientid" formControlName="patientId" [id]="
        identifierService.dropdownId(
            'baseline-clinical-data',
            'patientid'
        )
    " />
    </div>

    <form [formGroup]="baselineClinicalDataFormGroup">
      <div class="row middle-xs">
        <div class="col-xs-3">
          <div [id]="identifierService.labelId('baselineClinicalData', 'title')" class="pageTitle" data-tx-key="label.gb.baseline_clinical_data">{{ labels['label.gb.baseline_clinical_data'] }}</div>
        </div>
        <div class="col-xs-3">
          @if (profileMode()) {
            <div>
              @if (viewMode()) {
<button mat-raised-button color="primary" style="margin-right: 5px" (click)="setDisplayMode('edit')" [id]="
                        identifierService.dropdownId(
                            'baseline-clinical-data',
                            'editBtn'
                        )
                    " [disabled]="!hasPatientDataEntryAccess" data-tx-key="label.gb.edit">
                  {{ labels['label.gb.edit'] }}
                </button>
              }
              @if (editMode()) {
                <button mat-raised-button class="mr-20" color="accent" (click)="onCancelEditClick()" [id]="
                        identifierService.dropdownId(
                            'baseline-clinical-data',
                            'cancelBtn'
                        )
                    " data-tx-key="label.gb.button_cancel">
                  {{ labels['label.gb.button_cancel'] }}
                </button>
              }
              @if (editMode()) {
                <button mat-raised-button color="primary" class="mr-5" (click)="onSaveButtonClick()" [id]="
                        identifierService.dropdownId(
                            'baseline-clinical-data',
                            'saveBtn'
                        )
                    " data-tx-key="label.gb.save">
                  {{ labels['label.gb.save'] }}
                </button>
              }
            </div>
          }
        </div>
        <div class="col-xs-offset-1 col-xs-5 end-xs end_flex">

          <div class="tool__link">
            @if (profileMode()) {
              <div >
                <div class="figLink" (click)="openPrintDialog()" id="baseline-clinical-data-print-profile"
                  data-tx-key="label.gb.print_profile">
                  {{ labels['label.gb.print_profile'] }}
                </div>
              </div>
            }
            @if (viewMode()) {
              <div [id]="identifierService.buttonId('baselineClinicalData', 'releasePatient')" class="figLink"
                [ngStyle]="{'pointer-events': isSP2CanEnroll ? 'auto' :'none', 'color': isSP2CanEnroll ? '#03a9f4' : '#9e9e9e'}"
                (click)="releasePatient()">
                {{ labels['label.gb.release_patient'] }}
              </div>
            }
            @if (viewMode()) {
              <div class="figLink">
                <a [id]="identifierService.buttonId('baselineClinicalData', 'more_actions')" [matMenuTriggerFor]="menu" #trigger="matMenuTrigger">{{
                  labels['label.gb.more_actions']
                  }}
                &#8942;</a>
              </div>
            }
          </div>
        </div>
      </div>
      <mat-menu #menu="matMenu">
            <button mat-menu-item [id]="
            identifierService.dropdownId(
                'baseline-clinical-data',
                'reactivate_pat'
            )" (click)="reActivatePatient()" [disabled]="!hasPatientDataEntryAccess" data-tx-key="label.gb.reactivate_pat">
          {{ labels['label.gb.reactivate_pat'] }}
        </button>
        <!-- <button mat-menu-item
            [id]="
            identifierService.dropdownId(
                'baseline-clinical-data',
                'release_pat'
            )"
            (click)="releasePatient()
        "
        [disabled]="!isSP2CanEnroll">
        {{ 'label.gb.release_patient'] }}
      </button> -->
    </mat-menu>
    <br />
    @if (displayMode == 'view') {
      <div>
        @if (isPatientRelease) {
          <div class="yellow-card">
            <span [id]="identifierService.labelId('baselineClinical', 'releasePatientMsg')" [innerHTML]="releasePatientMsg"></span>
          </div>
        }
      </div>
    }
    <hr />
    <mat-label [id]="identifierService.labelId('baselineClinical', 'recordBaselineMeasurements')" data-tx-key="label.gb.record_baseline_measurements">{{ labels['label.gb.record_baseline_measurements'] }}
    </mat-label>
    <div class="row mt-15">
      <div class="col-xs-3 col-xs-offset-1 gridActionPanel">
        @if (showBaselineTextValue()) {
          <div class="row" style="margin-bottom: 20px">
            <div [id]="identifierService.labelId('baselineClinicalData', 'dateBaselineTaken')" data-tx-key="label.gb.date_baseline_taken">
              {{ labels['label.gb.date_baseline_taken'] }}:
            </div>
            <div [id]="identifierService.labelId('baselineClinicalData', 'baseLineDateValue')" style="margin-left: 10px">
              {{ baselineClinicalData ? baselineClinicalData.baseLineDate : '' }}
            </div>
          </div>
        }
        @if (showBaselineInputBox()) {
          <merlin-textbox [maxLength]="10" [required]="requiredBasLineDate" label="{{ labels['label.gb.date_baseline_taken'] }}" placeHolder="{{ datePlaceholder }}" controlName="baseLineDate" [groupName]="baselineClinicalDataFormGroup"
                          class="BaselineDateInput"
                          [id]="
                            identifierService.dropdownId(
                                'baseline-clinical-data',
                                'baseLineDate'
                            )
                        " (blured)="onBlur($event)" data-tx-key="label.gb.date_baseline_taken">
            <!-- -->
          </merlin-textbox>&nbsp;&nbsp;&nbsp;
        }
      </div>
      <div class="col-xs-4 gridActionPanel">`
        @if (showBaselineTextValue()) {
          <div class="row" style="margin-bottom: 20px">
            <div [id]="identifierService.labelId('baselineClinicalData', 'pacemakerDependent')" data-tx-key="label.gb.pacemaker_dependent">
              {{ labels['label.gb.pacemaker_dependent'] }}:
            </div>
            <div [id]="identifierService.labelId('baselineClinicalData', 'pacemakerDependentValue')" style="margin-left: 10px">
              {{ getPacemakerCd() }}
            </div>
          </div>
        }
        @if (showBaselineInputBox()) {
          <mat-form-field appearance="outline" class="baseline-form-field">
            <mat-label [id]="identifierService.labelId('baselineClinical', 'pacemakerDependent')" data-tx-key="label.gb.pacemaker_dependent">{{ labels['label.gb.pacemaker_dependent'] }}
            </mat-label>
                        <mat-select disableOptionCentering placeholder="{{
                                labels['label.gb.pacemaker_dependent']
                            }}"  formControlName="pacemakerDependentCd" [id]="
                            identifierService.dropdownId(
                                'baseline-clinical-data',
                                'pacemakerDependentCd'
                            )"
              data-tx-key="label.gb.pacemaker_dependent">
              <mat-option> </mat-option>
              @for (
                eachObj of baselineClinicalData?.pacemakerDependentList
                ; track
                eachObj) {
                <mat-option [id]="identifierService.listitemId('baselineClinical', 'option_' + eachObj.codeId)" value="{{ eachObj.codeId }}">
                  {{ getDDLabel(eachObj) }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
      </div>
    </div>
    <div class="row">
      <div class="col-xs-4">
        <h3 [id]="identifierService.labelId('baselineClinicalData', 'hfInfoHeader')" class="merlin-header" data-tx-key="label.gb.HF_info">
          {{ labels['label.gb.HF_info'] }}
        </h3>
        <hr />
        <div class="row mt-15">
          <div class="col-xs-6 col-xs-offset-1">
                        <merlin-textbox label="{{ labels['label.gb.qrs_width'] }}" placeHolder="{{
                                labels['label.gb.qrs_width']
                            }}" maxLength="5" (input)="onTextboxChange($event)" controlName="qrsWidth" [groupName]="baselineClinicalDataFormGroup" [readOnly]="!enableUIElement()" [id]="
                            identifierService.dropdownId(
                                'baseline-clinical-data',
                                'qrsWidth'
                            )"
              data-tx-key="label.gb.qrs_width">
            </merlin-textbox>
          </div>
          <span [id]="identifierService.labelId('baselineClinicalData', 'ms')" data-tx-key="label.gb.ms" class="pt-8">{{ labels['label.gb.ms'] }}</span>
        </div>
        <div class="row">
          <div class="col-xs-6 col-xs-offset-1">
                        <merlin-textbox label="{{ labels['label.gb.ef'] }}" placeHolder="EF:" controlName="ef" maxLength="3" (input)="onTextboxChange($event)" [groupName]="baselineClinicalDataFormGroup" [readOnly]="!enableUIElement()" [id]="
                            identifierService.dropdownId(
                                'baseline-clinical-data',
                                'ef'
                            )
                        ">
            </merlin-textbox>
          </div>
          <span [id]="identifierService.labelId('baselineClinicalData', 'percentage')" data-tx-key="label.gb.percentage" class="pt-8">{{ labels['label.gb.percentage'] }}</span>
        </div>
        <div class="row">
          <div class="col-xs-6 col-xs-offset-1">
            <mat-form-field appearance="outline" class="baseline-form-field">
              <mat-label [id]="identifierService.labelId('baselineClinical', 'nyhaClassification')" data-tx-key="label.gb.nyha_classification">{{ labels['label.gb.nyha_classification'] }}
              </mat-label>
                            <mat-select disableOptionCentering placeholder="{{ labels['label.gb.nyha_classification']}}" formControlName="nyhaClassificationCd" (selectionChange)="onDropDownChange($event)"  [disabled]="!enableUIElement()" [id]="
                                identifierService.dropdownId(
                                    'baseline-clinical-data',
                                    'nyhaClassificationCd'
                                )"
                data-tx-key="label.gb.nyha_classification">
                <mat-option> </mat-option>
                @for (
                  eachObj of baselineClinicalData?.nyhaClassificationList
                  ; track
                  eachObj) {
                  <mat-option [id]="identifierService.listitemId('baselineClinicalData', 'nyhaOption_' + eachObj.codeId)" [value]="eachObj.codeId">
                    {{ getDDLabel(eachObj) }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="col-xs-8">
        <h3 [id]="identifierService.labelId('baselineClinicalData', 'historyHeader')" class="merlin-header" data-tx-key="label.gb.history">
          {{ labels['label.gb.history'] }}
        </h3>
        <hr />
        <div class="row">
          <div class="col-xs-6">
            <span [id]="identifierService.labelId('baselineClinicalData', 'cardiovascular')" class="fontClass" data-tx-key="label.gb.cardiovascular">{{
              labels['label.gb.cardiovascular']
            }}</span>
            <div class="row mt-10">
              <div class="col-xs-5">
                                <mat-checkbox color="primary" formControlName="anginaSelected" (change)="onChange($event)" [disabled]="!enableUIElement()" [id]="
                                    identifierService.dropdownId(
                                        'baseline-clinical-data',
                                        'anginaSelected'
                                    )"
                  data-tx-key="label.gb.angina">
                  {{ labels['label.gb.angina'] }}
                </mat-checkbox><br />
                                <mat-checkbox color="primary" formControlName="miselected" (change)="onChange($event)" [disabled]="!enableUIElement()" [id]="
                                    identifierService.dropdownId(
                                        'baseline-clinical-data',
                                        'miselected'
                                    )
                                " data-tx-key="label.gb.MI">
                  {{ labels['label.gb.MI'] }}
                </mat-checkbox><br />
                                <mat-checkbox color="primary" formControlName="cardioPTCAFlg" (change)="onChange($event)" [disabled]="!enableUIElement()" [id]="
                                    identifierService.dropdownId(
                                        'baseline-clinical-data',
                                        'cardioPTCAFlg'
                                    )
                                " data-tx-key="label.gb.PTCA">
                  {{ labels['label.gb.PTCA'] }}
                </mat-checkbox><br />
                                <mat-checkbox color="primary" formControlName="cardioCABGFlg" (change)="onChange($event)" [disabled]="!enableUIElement()" [id]="
                                    identifierService.dropdownId(
                                        'baseline-clinical-data',
                                        'cardioCABGFlg'
                                    )
                                " data-tx-key="label.gb.CABG">
                  {{ labels['label.gb.CABG'] }}
                </mat-checkbox><br />
              </div>
              <div class="col-xs-2">
                                <mat-checkbox color="primary" formControlName="cardioValveDiseaseFlg" (change)="onChange($event)" [disabled]="!enableUIElement()" [id]="
                                    identifierService.dropdownId(
                                        'baseline-clinical-data',
                                        'cardioValveDiseaseFlg'
                                    )
                                " data-tx-key="label.gb.valve_disease">
                  {{ labels['label.gb.valve_disease'] }}
                </mat-checkbox><br />
                                <mat-checkbox color="primary" formControlName="cardioHypertensionFlg" (change)="onChange($event)" [disabled]="!enableUIElement()" [id]="
                                    identifierService.dropdownId(
                                        'baseline-clinical-data',
                                        'cardioHypertensionFlg'
                                    )
                                " data-tx-key="label.gb.hypertension">
                  {{ labels['label.gb.hypertension'] }}
                </mat-checkbox><br />
              </div>
            </div>
          </div>
          <div class="col-xs-6">
            <span [id]="identifierService.labelId('baselineClinicalData', 'hypertension')" class="fontClass" data-tx-key="label.gb.hypertension">{{
              labels['label.gb.arrhythmia']
            }}</span>
            <div class="row mt-10">
              <div class="col-xs-5">
                                <mat-checkbox color="primary" formControlName="arrhythmiaAtFlg" (change)="onChange($event)" [disabled]="!enableUIElement()" [id]="
                                    identifierService.dropdownId(
                                        'baseline-clinical-data',
                                        'arrhythmiaAtFlg'
                                    )
                                " data-tx-key="label.gb.at">
                  {{ labels['label.gb.at'] }}
                </mat-checkbox><br />
                                <mat-checkbox color="primary" formControlName="arrhythmiaAFParoxysmalFlg" (change)="onChange($event)" [disabled]="!enableUIElement()" [id]="
                                    identifierService.dropdownId(
                                        'baseline-clinical-data',
                                        'arrhythmiaAFParoxysmalFlg'
                                    )
                                " data-tx-key="label.gb.AF_paroxysmal">
                  {{ labels['label.gb.AF_paroxysmal'] }}
                </mat-checkbox><br />
                                <mat-checkbox color="primary" formControlName="arrhythmiaAFChronicFlg" (change)="onChange($event)" [disabled]="!enableUIElement()" [id]="
                                    identifierService.dropdownId(
                                        'baseline-clinical-data',
                                        'arrhythmiaAFChronicFlg'
                                    )
                                " data-tx-key="label.gb.AR_chronic">
                  {{ labels['label.gb.AR_chronic'] }}
                </mat-checkbox><br />
                                <mat-checkbox color="primary" formControlName="arrhythmiaAflFlg" (change)="onChange($event)" [disabled]="!enableUIElement()" [id]="
                                    identifierService.dropdownId(
                                        'baseline-clinical-data',
                                        'arrhythmiaAflFlg'
                                    )
                                " data-tx-key="label.gb.afl">
                  {{ labels['label.gb.afl'] }}
                </mat-checkbox><br />
              </div>
              <div class="col-xs-2">
                                <mat-checkbox color="primary" formControlName="arrhythmiaVtFlg" (change)="onChange($event)" [disabled]="!enableUIElement()" [id]="
                                    identifierService.dropdownId(
                                        'baseline-clinical-data',
                                        'arrhythmiaVtFlg'
                                    )
                                " data-tx-key="label.gb.vt">
                  {{ labels['label.gb.vt'] }}
                </mat-checkbox><br />
                                <mat-checkbox color="primary" formControlName="arrhythmiaVfFlg" (change)="onChange($event)" [disabled]="!enableUIElement()" [id]="
                                    identifierService.dropdownId(
                                        'baseline-clinical-data',
                                        'arrhythmiaVfFlg'
                                    )
                                " data-tx-key="label.gb.vf">
                  {{ labels['label.gb.vf'] }}
                </mat-checkbox><br />
                                <mat-checkbox color="primary" formControlName="arrhythmiaPVCFlg" (change)="onChange($event)" [disabled]="!enableUIElement()" [id]="
                                    identifierService.dropdownId(
                                        'baseline-clinical-data',
                                        'arrhythmiaPVCFlg'
                                    )
                                " data-tx-key="label.gb.PVC">
                  {{ labels['label.gb.PVC'] }}
                </mat-checkbox><br />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <h3 [id]="identifierService.labelId('baselineClinicalData', 'indicationsHeader')" class="merlin-header" data-tx-key="label.gb.indications">
          {{ labels['label.gb.indications'] }}
        </h3>
        <hr />
        <div [ngClass]="{ hideBucket: !showBucketList() }">
          <div class="col-xs-6 col-xs-offset-1">
                        <input type="hidden" name="availableIndications" formControlName="optionTransferAssignedIndications" [id]="
                            identifierService.dropdownId(
                                'baseline-clinical-data',
                                'optionTransferAssignedIndications'
                            )
                        " />
                        <input type="hidden" name="assignedIndications" formControlName="indications" [id]="
                            identifierService.dropdownId(
                                'baseline-clinical-data',
                                'indications'
                            )
                        " />
                        <merlin-bucket-list [leftSelectBox]="availableIndications" [showEmptyMessage]="false" [rightSelectBox]="assignedIndications" [rightSelectBoxDisabled]="false" [leftSelectBoxDisabled]="false" displayKey="label" id="IndicationList" (rightSelectBoxUpdated)="
                                rightSelectBoxUpdated_click($event)
                            ">
                </merlin-bucket-list>
              </div>
            </div>
                <div [hidden]="!showIndicationsList()" style="
                        background-color: white;
                        width: 350px;
                        height: 100px;
                        border: solid 1px rgb(180, 180, 180);
                        overflow-y: scroll;
                        margin-bottom: 10px;
                    ">
              @for (indic of assignedIndications; track indic) {
                <div [id]="identifierService.labelId('baselineClinicalData', 'indication_' + indic?.codeId)">
                  {{ getDDLabel(indic) }}
                </div>
              }
            </div>
          </div>
        </div>
        @if (baseLineInvalid) {
          <div [id]="identifierService.labelId('baselineClinicalData', 'requiredField')" style="color: red" data-tx-key="label.gb.required_field">* {{ labels['label.gb.required_field']}}</div>
        }
        @if (!profileMode()) {
          <div class="col-xs-6 col-xs-offset-8">
            <button mat-raised-button class="btn-styl" color="accent" (click)="back()" [id]="
              identifierService.buttonId(
                  'baseline-clinical-data',
                  'enrollBackButton'
              )
              " data-tx-key="label.gb.back">
              {{ labels['label.gb.back'] }}</button
              >&nbsp;&nbsp;
              <button
                mat-raised-button
                class="btn-styl"
                color="accent"
                (click)="cancel()"
                [id]="
                    identifierService.buttonId(
                        'baseline-clinical-data',
                        'enrollCancelButton'
                    )
                    "
                >
                {{ labels['label.gb.button_cancel'] }}</button
                >&nbsp;&nbsp;
                <button
                  mat-raised-button
                  class="btn-styl"
                  color="primary"
                  (click)="submitForm()"
                  [id]="
                    identifierService.buttonId(
                        'baseline-clinical-data',
                        'enrollContinueButton'
                    )
                    "
                  >
                  {{ labels['label.gb.continue'] }}
                </button>
              </div>
            }
          </form>
        </div>
